import { render, staticRenderFns } from "./DownTimeItem.vue?vue&type=template&id=08625e3c&scoped=true&"
import script from "./DownTimeItem.vue?vue&type=script&lang=js&"
export * from "./DownTimeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08625e3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08625e3c')) {
      api.createRecord('08625e3c', component.options)
    } else {
      api.reload('08625e3c', component.options)
    }
    module.hot.accept("./DownTimeItem.vue?vue&type=template&id=08625e3c&scoped=true&", function () {
      api.rerender('08625e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DownTime/DownTimeItem.vue"
export default component.exports